import { render, staticRenderFns } from "./ReportStatusTable.vue?vue&type=template&id=5620c976"
import script from "./ReportStatusTable.vue?vue&type=script&lang=js"
export * from "./ReportStatusTable.vue?vue&type=script&lang=js"
import style0 from "./ReportStatusTable.vue?vue&type=style&index=0&id=5620c976&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports